/**
 * Le tableau de bord statistiques (V2 §6) — **trois lectures, aucune écriture**.
 *
 * 🔴 **Aucune mutation ici, et ce n'est pas un oubli.** Le §6.1 refuse toute
 * table de statistiques : il n'existe rien à écrire, donc rien à mettre en file
 * (`shared/syncable.ts` n'a pas changé à cette étape).
 *
 * ⚠️ **`today` vient de l'APPAREIL** (`browserToday()`), comme pour le poids.
 * Ce qu'un écran appelle « les 30 derniers jours » doit se compter depuis le
 * jour de l'appareil qu'on tient — c'est la première moitié de l'invariant de
 * fuseau, et la route valide la date plutôt que de la remplacer en silence.
 *
 * ⚠️ **Trois clés de cache distinctes, jamais une réponse fourre-tout.** Chaque
 * sous-onglet ne demande que ce qu'il affiche : ouvrir « Nutrition » n'a aucune
 * raison de calculer le volume par groupe musculaire sur cinq ans. C'est aussi
 * ce qui donne son sens au seuil du §6.1, qui parle de « chaque **écran** ».
 */

import type {
  HealthStatsResponse,
  NutritionStatsResponse,
  StatsRange,
  TrainingStatsResponse,
} from '../../../shared/types';
import { browserToday } from '../lib/dates';
import { apiFetch } from './client';

export function nutritionStatsKey(range: StatsRange) {
  return ['stats-nutrition', range] as const;
}
export function trainingStatsKey(range: StatsRange) {
  return ['stats-training', range] as const;
}
export function healthStatsKey(range: StatsRange) {
  return ['stats-health', range] as const;
}

function params(range: StatsRange): string {
  return new URLSearchParams({ range, today: browserToday() }).toString();
}

export function fetchNutritionStats(range: StatsRange): Promise<NutritionStatsResponse> {
  return apiFetch<NutritionStatsResponse>(`/api/stats/nutrition?${params(range)}`);
}

export function fetchTrainingStats(range: StatsRange): Promise<TrainingStatsResponse> {
  return apiFetch<TrainingStatsResponse>(`/api/stats/training?${params(range)}`);
}

export function fetchHealthStats(range: StatsRange): Promise<HealthStatsResponse> {
  return apiFetch<HealthStatsResponse>(`/api/stats/health?${params(range)}`);
}
